<template>
  <Spacer />
  <section class="section" aria-labelledby="contact-heading" v-if="false">
    <div id="contact-us">
      <div class="hero">
        <div class="content">
          <h2 v-if="isPortrait">Tr</h2>
          <h1 v-else>Travvir</h1>
          <div class="icons-wrapper" aria-label="Download our app">
            <a
              href="https://play.google.com/store/apps/details?id=com.travvir.studio"
              target="_blank"
              rel="noopener noreferrer"
              ><NuxtImg
                format="avif"
                :src="`${baseUrl}/static/images/PlayStore.png`"
                alt="Get it on Google Play"
                loading="lazy"
                :placeholder="`${baseUrl}/property-preview-images-web/default.svg`"
            /></a>
            <a
              href="https://apps.apple.com/in/app/travvir-360-views-from-phone/id6443536819"
              target="_blank"
              rel="noopener noreferrer"
              ><NuxtImg
                format="avif"
                :src="`${baseUrl}/static/images/AppStore.png`"
                alt="Download on the App Store"
                loading="lazy"
                :placeholder="`${baseUrl}/property-preview-images-web/default.svg`"
            /></a>
          </div>
        </div>
        <div class="right_side">
          <div class="right_side_content">
            <div class="tag-containers">
              <div class="links_container">
                <ul class="links">
                  <li>
                    <NuxtLink to="/about" prefetch-on="visibility"
                      >About us</NuxtLink
                    >
                  </li>
                  <li>
                    <NuxtLink to="/docs" prefetch-on="visibility"
                      >Docs</NuxtLink
                    >
                  </li>
                  <li>
                    <NuxtLink to="/partnership" prefetch-on="visibility"
                      >Partnerships</NuxtLink
                    >
                  </li>
                  <li>
                    <NuxtLink to="/enterprise" prefetch-on="visibility"
                      >Enterprise</NuxtLink
                    >
                  </li>
                  <li>
                    <a
                      @click="handleOsBasedRedirection"
                      target="_blank"
                      rel="noopener noreferrer"
                      >Login</a
                    >
                  </li>
                </ul>
              </div>
              <div class="links_container">
                <ul class="links" @click="handleHashLink">
                  <!-- <li><NuxtLink to="/about">About Us</NuxtLink></li> -->
                  <li>
                    <NuxtLink to="/privacy-policy">Privacy Policy</NuxtLink>
                  </li>
                  <li><NuxtLink to="/credits">Credits</NuxtLink></li>
                  <li><NuxtLink to="/terms">Terms of Use</NuxtLink></li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/travvir/"
                      rel="noopener noreferrer"
                      >LinkedIn</a
                    >
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://x.com/Travvir_AI"
                      rel="noopener noreferrer"
                      >X.com</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="left-row">
              <div class="need-help-section">
                <span class="help"><h5>Need Help?</h5></span>
                <div class="help-contacts">
                  <div class="help-item">
                    <p class="help-text">Sales</p>
                    <a href="tel:+18889938990" class="help-link">
                      +1 (650) 334-0997
                    </a>
                  </div>
                  <div class="help-item">
                    <p class="help-text">Support</p>
                    <a href="tel:+14088053347" class="help-link">
                      operations@travvir.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end col-->
      </div>
      <div class="rights">
        <h3>© {{ new Date().getFullYear() }} Creative Clutch.</h3>
        <h2>All rights are reserved.</h2>
      </div>
    </div>
  </section>
</template>

<script setup>
import axios from "axios";

// Reactive data
const isPortrait = inject("isPortrait");
const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL;
const name = ref(null);
const email = ref(null);
const mobile = ref(null);
const countryCode = ref(1);
const submit = ref(false);
const flash = ref(false);
const isNameToggle = ref(false);
const isEmailToggle = ref(false);
const isMobileToggle = ref(false);
const msg = ref(null);
const nameInput = ref(null);
const emailInput = ref(null);
const mobileInput = ref(null);

// Methods
const handler = async () => {
  try {
    const form = document.querySelector("form");
    const mobileRegix = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    let mobilenumber = `+${countryCode.value}${mobile.value}`;

    //empty check
    if (!(name.value && email.value)) return;
    if (mobile.value) {
      if (!mobileRegix.test(mobilenumber)) {
        isMobileToggle.value = true;
        notify("mobile");
        msg.value = "Please Enter Valid Mobile No.";
        return;
      }
    }
    //queue check
    if (submit.value) return;
    const url = config.public.NUXT_API_URL + "/contact";
    submit.value = true;
    const res = await axios.post(url, {
      name: name.value,
      email: email.value,
      mobile: mobilenumber,
      message: "Contact from Travvir Footer Form",
    });
    if (res.status == 200) {
      form.reset();
      isNameToggle.value = isEmailToggle.value = isMobileToggle.value = false;
      name.value = email.value = mobile.value = null;
      submit.value = false;
      msg.value = " We will contact you shortly.";
      notify("success");
    }
  } catch (error) {
    msg.value = error.response.data?.message;
    submit.value = false;
    notify("error");
  }
};

const notify = (info) => {
  if (info == "mobile") {
    flash.value = true;
    setTimeout(() => {
      flash.value = false;
    }, 3000);
  } else {
    flash.value = true;
    setTimeout(() => {
      flash.value = false;
    }, 3000);
  }
};

const handleSpan = (event) => {
  if (event == "name") {
    nameInput.value.focus();
    isNameToggle.value = true;
  } else if (event == "email") {
    emailInput.value.focus();
    isEmailToggle.value = true;
  } else if (event == "mobile") {
    mobileInput.value.focus();
    isMobileToggle.value = true;
  }
  return;
};

const handleHashLink = () => {
  window.scrollTo(0, 0);
};
</script>

<style lang="scss" scoped>
.icons-wrapper {
  gap: 1rem;
  z-index: 100;
  display: flex;
  position: relative;
  width: fit-content;
  padding-left: 0.15rem;
  a {
    width: 10rem;
    img {
      width: 100%;
    }
  }
  @include respond-below(md) {
    display: none;
  }
}
.right_side {
  // background-color: royalblue;
  width: calc(100% - 50%);
  display: block;
  @include respond-below(lg) {
    width: 50%;
  }
  @include respond-below(md) {
    width: 100%;
  }
  &_content {
    justify-content: right;
    align-items: center;
    padding-bottom: 3rem;
    display: flex;
    gap: 2rem;
    @include respond-below(lg) {
      gap: 1.5rem;
    }
    @include respond-below(md) {
      flex-direction: column;
      padding-bottom: 1rem;
      display: flex;
      .contact {
        justify-content: center;
      }
    }
  }
}
section.section {
  // padding: 2rem 0rem;
  margin: auto;
  max-width: 1200px;
  width: 100%;
  justify-content: center;
  font-family: $theme-font;
  display: flex;
  flex-direction: column;
  .hero {
    margin-top: 2rem;
    padding: 3rem 0rem;
    height: 100%;
    min-height: 40vh;
    // background-color: #999;
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    @include respond-below(lg) {
      padding: 3rem 2rem;
    }
    @include respond-below(md) {
      flex-direction: column;
      align-items: end;
      padding: 0rem 1rem;
      gap: 0rem;
    }
    @include respond-below(sm) {
      justify-content: center;
      align-items: center;
      min-height: 85vh;
    }
    .content {
      height: 100%;
      width: 50%;
      height: 18.75rem;
      display: flex;
      flex-direction: column;
      align-items: left;
      justify-content: space-between;
      // padding-bottom: 3rem;
      gap: 0rem;
      @include respond-below(lg) {
        width: 50%;
      }
      @include respond-below(md) {
        gap: 1rem;
      }
      @include mq(landscape-1) {
        gap: 1rem;
      }
      @include respond-below(md) {
        width: 100%;
        height: fit-content;
        padding-bottom: 0rem;
        justify-content: start;
      }
    }
    h1,
    h2 {
      font-style: normal;
      // font-weight: 600;
      font-size: 11.5rem;
      line-height: 110%;
      color: #ffffff;
      @include respond-below(lg) {
        font-size: 9.5rem;
      }
      @include respond-below(md) {
        margin-bottom: 0rem;
        font-size: 4rem;
        padding: 0rem 1rem;
      }
    }
  }
}
.tag-containers {
  display: flex;
  gap: 2rem;
  @include respond-below(lg) {
    gap: 1.5rem;
  }
  @include respond-below(md) {
    gap: 1rem;
    width: 100%;
  }
  .links_container {
    @extend %v-center;
    justify-content: flex-end;
    height: calc(2rem * 7.4);
    margin-top: 1.2rem;
    @include respond-below(md) {
      height: 100%;
      gap: 1rem;
      justify-content: center;
    }
    ul {
      color: white;
      white-space: nowrap;
      overflow: hidden;
      flex-wrap: nowrap;
      gap: 0rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      list-style: none;
      font-style: normal;
      color: #ffffff;
      @include respond-below(md) {
        line-height: 1.2;
        gap: 0.5rem;
        justify-content: space-around;
      }
      @include mq(landscape-1) {
        margin-left: 0rem;
        line-height: 0.9;
        gap: 0rem;
        justify-content: space-around;
      }
      li {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.9);
        cursor: pointer;
        line-height: 2.1rem;
        padding: 0.25rem 1rem;
        // margin-right: 1.5rem;
        border-radius: 6px;
        @include respond-below(md) {
          line-height: unset;
          line-height: 1.4;
        }
      }
      a {
        color: rgba(255, 255, 255, 0.496);
        padding: 0.25rem 0rem;
        // font-weight: 400;
        text-decoration: none;
      }
    }
  }
}
.need-help-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1.3rem;
  @include respond-below(md) {
    align-items: center;
    margin-bottom: 1rem;
  }
  @include respond-below(md) {
    align-items: flex-start;
    padding-left: 0.7rem;
  }
  .help-contacts {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;

    @include respond-below(md) {
      align-items: center;
      gap: 0.5rem;
    }
    @include respond-below(md) {
      align-items: flex-start;
    }
  }

  .help-item {
    padding-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;

    @include respond-below(md) {
      align-items: center;
    }
    @include respond-below(md) {
      align-items: flex-start;
    }

    .help-text,
    .help-link {
      font-size: 1rem;
      color: rgba(255, 255, 255, 0.914);
      @include respond-below(md) {
        align-items: center;
        padding: 0.2rem 0.5rem;
        line-height: 0.9;
      }
      @include respond-below(md) {
        align-items: flex-start;
      }
    }

    .help-link {
      color: rgba(255, 255, 255, 0.496);
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.left-row {
  @include respond-below(md) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
}
.rights {
  margin: 1.5rem 0rem;
  display: none;
  justify-content: start;
  padding-left: 2rem;
  @include respond-below(md) {
    padding: 0rem 2rem;
    flex-direction: column;
  }
  h3 {
    font-size: 0.875rem;
    // font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    text-decoration: unset;
    padding-right: 0.2rem;
    // margin-right: 2rem;
    @include respond-below(md) {
      font-size: 0.775rem;
      text-align: start;
      line-height: 1.25rem;
      padding: 0.2rem 0rem;
      padding-top: 0rem;
    }
  }
  h2 {
    font-size: 0.875rem;
    // font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    text-decoration: unset;
    // margin-right: 2rem;
    @include respond-below(md) {
      // margin-top: 2rem;
      font-size: 0.775rem;
      text-align: start;
      line-height: 1.25rem;
      padding: 0.2rem 0rem;
      padding-top: 0rem;
    }
  }
}
.help {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.914);
  margin: 0 0 1rem 0;
  h5 {
    font-weight: bolder;
    // font-size: 1rem;
  }

  @include respond-below(md) {
    margin-bottom: 0.75rem;
  }
  @include respond-below(md) {
    padding: 0.5rem 0.5rem;
  }
}
</style>
